/** @file Binary search of the key segment containing a time. */

/** Index i such that times[i] <= t < times[i+1]; -1 before the first key; last index after the last key. */
export function findSegment(times: Float64Array, t: number): number {
  // Upper bound: the first index whose time is > t; the segment starts one before it. NaN compares false -> -1.
  let lo = 0;
  let hi = times.length;
  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    if ((times[mid] ?? 0) <= t) lo = mid + 1;
    else hi = mid;
  }
  return lo - 1;
}
